import React, { useReducer } from "react";
import { ProductInitialState } from "./ProductInitialState";
import { productReducer } from "./ProductReducer";

export const ProductContext = React.createContext({
  productState: ProductInitialState,
  dispatch: () => null,
});

const ProductProvider = (props) => {
  const [state, dispatch] = useReducer(productReducer, ProductInitialState);

  // }, []);

  return (
    <ProductContext.Provider value={{ productState: state, dispatch }}>
      {props.children}
    </ProductContext.Provider>
  );
};

export default ProductProvider;
